export default __webpack_public_path__ + "static/13-ee17a5fb304e74c956a2a710973d8507.jpg";